export * from "./aqi";
export * from "./notifications";
export * from "./onboarding-types";
export * from "./report";
export interface LabelVal {
  label: string;
  value: any;
}
